var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTooltipIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12779_1732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9375 0.5625C8.5 0 9.46875 0 10.0625 0.5625L11.5 2H13.5C14.3125 2 15 2.6875 15 3.5V5.5L16.4062 6.9375C17 7.53125 17 8.46875 16.4062 9.0625L15 10.5V12.5C15 13.3438 14.3125 14 13.5 14H11.4688L10.0625 15.4375C9.46875 16 8.5 16 7.9375 15.4375L6.5 14H4.5C3.65625 14 3 13.3438 3 12.5V10.5L1.5625 9.0625C0.96875 8.46875 0.96875 7.53125 1.5625 6.9375L3 5.5V3.5C3 2.6875 3.65625 2 4.5 2H6.5L7.9375 0.5625ZM6.28125 5.1875V5.21875C6.15625 5.59375 6.34375 6.03125 6.75 6.1875C7.125 6.3125 7.5625 6.09375 7.6875 5.71875L7.71875 5.6875C7.75 5.59375 7.84375 5.5 7.9375 5.5H9.75C10.0312 5.5 10.2188 5.71875 10.2188 6C10.2188 6.15625 10.1562 6.3125 10 6.40625L8.625 7.1875C8.375 7.3125 8.21875 7.5625 8.21875 7.84375V8.25C8.21875 8.6875 8.5625 9 8.96875 9C9.40625 9 9.71875 8.6875 9.71875 8.28125L10.75 7.6875C11.3438 7.34375 11.7188 6.6875 11.7188 6C11.7188 4.90625 10.8438 4 9.75 4H7.9375C7.1875 4 6.53125 4.46875 6.28125 5.1875ZM10 11C10 10.4688 9.53125 10 9 10C8.4375 10 8 10.4688 8 11C8 11.5625 8.4375 12 9 12C9.53125 12 10 11.5625 10 11Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12779_1732",
    x: 0.96875,
    y: 0,
    width: 16.0312,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12779_1732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12779_1732",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIcon);
export default ForwardRef;